export function excelFleetReportDetailsColumns() {
  return [
    { key: 'description', header: 'Kostnadstype', width: 30 },
    { key: 'fixedCostsTerm', header: 'Faste kostnader', width: 20 },
    { key: 'nonFixedCostsTerm', header: 'Variable kostnader', width: 20 },
    { key: 'totalTerm', header: 'Sum', width: 15 },
    { key: 'totalYear', header: 'Hittil i år', width: 15 },
    { key: 'totalContract', header: 'Hittil i kontrakt', width: 20 },
  ]
}
